<template lang="pug">
  .select-items-skeleton
    .heading-bar
    section
      .row
        .field-bar
        .field-bar
    section
      .title-bar
      .product-row(v-for="i in 2" :key="i")
        .checkbox-bar
        .lines
          .line
          .line.line--short
    section
      .textarea-bar
      .info-line-bar
      .button-bar
</template>
<script setup lang="ts">
</script>
<style lang="scss" scoped>
@keyframes skeleton-loading {
  0% { background-color: $color-gray; }
  100% { background-color: $color-gray-light; }
}

%skeleton-bar {
  border-radius: $border-width-thick;
  animation: skeleton-loading 0.8s linear infinite alternate;
}

section {
  margin-bottom: $space-m;
}

.heading-bar {
  @extend %skeleton-bar;
  height: $size-l;
  width: 200px;
  max-width: 100%;
  margin-bottom: $space-m;
}

.row {
  display: flex;
  gap: $space-m;
  flex-direction: column;

  @include not-mobile {
    flex-direction: row;
  }
}

.field-bar {
  @extend %skeleton-bar;
  height: 44px;
  flex: auto;

  @include all-desktop() {
    flex: none;
    width: 33%;
  }
}

.title-bar {
  @extend %skeleton-bar;
  height: $size-xxxxl;
  max-width: 100%;
}

.product-row {
  display: flex;
  align-items: flex-start;
  gap: $space-s;
  padding: $space-s;
  border: $border-width-thin solid $color-gray;
  margin-top: -$border-width-thin;
}

.checkbox-bar {
  @extend %skeleton-bar;
  width: $size-l;
  height: $size-l;
  flex-shrink: 0;
  border-radius: 3px;
}

.lines {
  flex-grow: 1;
}

.line {
  @extend %skeleton-bar;
  height: $size-xs;
  width: 100%;
  margin-bottom: $space-xxs;

  &--short {
    width: 40%;
    margin-bottom: 0;
  }
}

.textarea-bar {
  border: 1px solid $color-gray;
  height: 100px;
  width: 100%;
  margin-bottom: $space-m;
}

.info-line-bar {
  @extend %skeleton-bar;
  height: $size-xs;
  width: 550px;
  max-width: 100%;
  margin-bottom: $space-m;
}

.button-bar {
  @extend %skeleton-bar;
  height: 44px;
  width: 100%;
  max-width: 100%;
  @include all-desktop() {
    width: 33%;
  }
}
</style>
